const FARMERS = {
  INDEX: "/farmer",
  FARMER_DETAILS: "/farmer/add",
  FARMER_EDIT: "/farmer/edit/:id",
  INSPECTION_BY_ID: "/farmer/detail/:id/:tab",
  INSPECTION_BY_ID_ADD: "/farmer/detail/:id/:tab/add",
  INSPECTION_BY_ID_EDIT: "/farmer/detail/:id/:tab/edit/:rowId",
};

const SUPPLIERS = {
  INDEX: "/suppliers",
  SUPPLIER_ADD: "/suppliers/add",
  SUPPLIER_EDIT: "/suppliers/edit/:id",
};

const MOLASSES = {
  INDEX: "/molasses",
  MOLASSES_ADD: "/molasses/add",
  MOLASSES_EDIT: "/molasses/edit/:id",
};

const FERMENTATION = {
  INDEX: "/fermentation",
  FERMENTATION_DETAILS: "/fermentation/add",
  FERMENTATION_EDIT: "/fermentation/edit/:id",
  CHEMISTRY_LOGS: "/fermentation/:id/chemistrylogs",
  CHEMISTRY_LOGS_ADD: "/fermentation/:id/chemistrylogs/add",
  CHEMISTRY_LOGS_EDIT: "/fermentation/:id/chemistrylogs/edit/:rowId",
};

const STRIPPING_PROCESS = {
  INDEX: "/strippingprocesslist",
  STRIPPING_PROCESS_BY_ID: "/strippingprocesslist/:id/strippingdata",
  STRIPPING_PROCESS_ADD: "/strippingprocesslist/:id/strippingdata/add",
  STRIPPING_PROCESS_EDIT: "/strippingprocesslist/:id/strippingdata/edit/:edit_id",

  WASTE_WATER_PROCESS_BY_ID: "/strippingprocesslist/:id/wastewater",
  WASTE_WATER_PROCESS_ADD: "/strippingprocesslist/:id/wastewater/add",
  WASTE_WATER_PROCESS_EDIT: "/strippingprocesslist/:id/wastewater/edit/:edit_id",
};

const SPIRIT_PROCESS = {
  INDEX: "/spiritprocesslist",
  SPIRIT_PROCESS_BY_ID: "/spiritprocesslist/:id/:tab",
  SPIRIT_PROCESS_ADD: "/spiritprocesslist/:id/:tab/add",
  SPIRIT_PROCESS_EDIT: "/spiritprocesslist/:id/:tab/edit/:edit_id",
};

const PROOFING = {
  INDEX: "/proofing",
  PROOFING_ADD: "/proofing/add",
  PROOFING_EDIT: "/proofing/edit/:id",
};

const CASK_AND_AGING = {
  INDEX: "/caskandaging",
  CASK_AND_AGING_ADD: "/caskandaging/add",
  CASK_AND_AGING_EDIT: "/caskandaging/edit/:id",
  SAMPLING_LOGS: "/caskandaging/:id/samplinglogs",
  SAMPLING_LOGS_ADD: "/caskandaging/:id/samplinglogs/add",
  SAMPLING_LOGS_EDIT: "/caskandaging/:id/samplinglogs/edit/:edit_id",
};

const BOTTLING = {
  INDEX: "/bottling",
  BOTTLING_ADD: "/bottling/add",
  BOTTLING_EDIT: "/bottling/edit/:id",
};

const CASK_MASTER = {
  INDEX: "/caskmaster",
  CASK_MASTER_ADD: "/caskmaster/add",
  CASK_MASTER_EDIT: "/caskmaster/edit/:id",
};

const CANE_VARIETY = {
  INDEX: "/canevariety",
  CANE_VARIETY_ADD: "/canevariety/add",
  CANE_VARIETY_EDIT: "/canevariety/edit/:id",
};

const RUM_TYPE = {
  INDEX: "/rumtype",
  RUM_TYPE_ADD: "/rumtype/add",
  RUM_TYPE_EDIT: "/rumtype/edit/:id",
};

const NUTRIENTS = {
  INDEX: "/nutrients",
  NUTRIENTS_ADD: "/nutrients/add",
  NUTRIENTS_EDIT: "/nutrients/edit/:id",
};

const USER_MANAGEMENT = {
  INDEX: "/user",
  USER_DETAILS_ADD: "/user/add",
  USER_DETAILS_EDIT: "/user/edit",
  USER_DETAILS_UPDATE: "/user/update/:id",
};

const DASHBOARD = {
  INDEX: "/dashboard",
};

const AI_ASSISTANT = {
  INDEX: "/ai-assistant",
};

const SETTINGS_AND_LISTS = {
  INDEX: "/settingsandlists",
};

const VESSEL_INVENTORY = {
  INDEX: "/vessel-inventory",
};

const BATCH_PASSPORT = {
  INDEX: "/batch-passport",
};

export {
  FARMERS,
  SUPPLIERS,
  MOLASSES,
  FERMENTATION,
  STRIPPING_PROCESS,
  SPIRIT_PROCESS,
  PROOFING,
  CASK_AND_AGING,
  BOTTLING,
  CASK_MASTER,
  CANE_VARIETY,
  RUM_TYPE,
  NUTRIENTS,
  USER_MANAGEMENT,
  DASHBOARD,
  AI_ASSISTANT,
  SETTINGS_AND_LISTS,
  VESSEL_INVENTORY,
  BATCH_PASSPORT,
};